import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { consoleDebug, isDebug } from '@shared/pipes/is-debug'

export const sendStep2SignForm = (code: string, optionalDocs?: string[]) => {
	if (isDebug()) {
		return consoleDebug('[Sign form] - prevent send form', code)
	}

	return httpService.post<{ verified: boolean }>(apiUrls.esia.verifySMSCode(code, optionalDocs))
}
